import { Icon } from '@chakra-ui/react';
import React from 'react';

const Key = props => {
  return (
    <Icon
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.15011 18.9583C5.06678 18.9583 4.97511 18.95 4.90011 18.9416L3.09178 18.6916C2.22511 18.575 1.44178 17.8 1.30845 16.9166L1.05845 15.0916C0.975114 14.5083 1.22511 13.75 1.64178 13.325L5.30011 9.66664C4.70845 7.29998 5.39178 4.79998 7.13345 3.07498C9.83345 0.38331 14.2251 0.374977 16.9334 3.07498C18.2418 4.38331 18.9584 6.12498 18.9584 7.97498C18.9584 9.82498 18.2418 11.5666 16.9334 12.875C15.1834 14.6083 12.6918 15.2916 10.3418 14.6916L6.67511 18.35C6.32511 18.7166 5.70011 18.9583 5.15011 18.9583ZM12.0251 2.29998C10.5668 2.29998 9.11678 2.84998 8.00845 3.95831C6.50845 5.44998 5.96678 7.63331 6.59178 9.66664C6.65845 9.89164 6.60011 10.125 6.43345 10.2916L2.51678 14.2083C2.37511 14.35 2.25845 14.7166 2.28345 14.9083L2.53345 16.7333C2.58345 17.05 2.92511 17.4083 3.24178 17.45L5.05845 17.7C5.25845 17.7333 5.62511 17.6166 5.76678 17.475L9.70011 13.55C9.86678 13.3833 10.1084 13.3333 10.3251 13.4C12.3334 14.0333 14.5251 13.4916 16.0251 11.9916C17.0918 10.925 17.6834 9.49164 17.6834 7.97498C17.6834 6.44998 17.0918 5.02498 16.0251 3.95831C14.9418 2.85831 13.4834 2.29998 12.0251 2.29998Z"
        fill="currentColor"
      />
      <path
        d="M7.65824 17.1166C7.4999 17.1166 7.34157 17.0583 7.21657 16.9333L5.2999 15.0166C5.05824 14.7749 5.05824 14.3749 5.2999 14.1333C5.54157 13.8916 5.94157 13.8916 6.18324 14.1333L8.0999 16.0499C8.34157 16.2916 8.34157 16.6916 8.0999 16.9333C7.9749 17.0583 7.81657 17.1166 7.65824 17.1166Z"
        fill="currentColor"
      />
      <path
        d="M12.0833 9.79163C11.0499 9.79163 10.2083 8.94996 10.2083 7.91663C10.2083 6.88329 11.0499 6.04163 12.0833 6.04163C13.1166 6.04163 13.9583 6.88329 13.9583 7.91663C13.9583 8.94996 13.1166 9.79163 12.0833 9.79163ZM12.0833 7.29163C11.7416 7.29163 11.4583 7.57496 11.4583 7.91663C11.4583 8.25829 11.7416 8.54163 12.0833 8.54163C12.4249 8.54163 12.7083 8.25829 12.7083 7.91663C12.7083 7.57496 12.4249 7.29163 12.0833 7.29163Z"
        fill="currentColor"
      />
    </Icon>
  );
};

export default Key;
